var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"events-page-layout d-flex"},[_c('CategorySelectMenu'),_c('MobileHeader',{attrs:{"selected-member":_vm.user}},[_c('CategoryCheckboxList')],1),_c('div',{staticClass:"flex-grow-1"},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }